import { FC } from 'react'
import styles from './index.module.scss'
import { getUserAvatar } from '../../../utils'
import { IJobBase } from '../../../types'
import { ProfileCard } from '../ProfileCard'

type Props = {
  name: string
  job: IJobBase
}

export const PrimaryRecruitingContactItem: FC<Props> = ({ name, job }) => {
  return (
    <div className={styles.container}>
      <div className={styles.name}>
        {name}
        <span>&nbsp;</span>:
      </div>
      <div className={styles.value}>
        <ProfileCard
          avatar={getUserAvatar(job?.primaryRecruitingContact)}
          name={job?.primaryRecruitingContact.name}
          jobTitle={job?.primaryRecruitingContact.profile.jobTitle}
          href={`/users/${job?.primaryRecruitingContact.username}`}
          isVerifiedAccount={job?.primaryRecruitingContact.profile.isVerifiedAccount}
        />
      </div>
    </div>
  )
}
